import { WSCard, WSInfoBox } from "@wingspanhq/fe-component-library";

type Props = {
  onUploadClick: () => void;
};

export const CardUploadNewDocument: React.FC<Props> = props => {
  return (
    <WSCard
      header={{
        label: {
          avatar: {
            type: "icon",
            icon: "upload",
            colorBackground: "gray600"
          },
          text: "Upload new document"
        }
      }}
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "Upload document",
            onClick: props.onUploadClick
          }
        ]
      }}
    >
      <WSInfoBox>
        To upload your Certificate of Insurance (COI), continue to upload
        document and follow the instructions. Once your document has been
        validated, your policies will be added to your “My resources” section
        and used in the policy matching process.
      </WSInfoBox>
    </WSCard>
  );
};
